/**
 * トップページMethodsエリア
 */
import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';

export default class homeMethods {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'homeMethods';
    this.isStart = false;
    this.scrollObject = [];

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    // Methodsのdom
    this.el = document.getElementById('l-home-methods');

    // スクロールで表示するdomを設定
    const title = this.el.querySelector('.p-home-title');
    TweenMax.set(title, {className: '+=is-hide'});
    this.scrollObject.push({
      el: title,
      delay: 0,
      isShow: false
    });

    this.el.querySelectorAll('.l-methods-index-category-body > li').forEach((el, index) => {
      TweenMax.set(el, {className: '+=is-hide'});
      this.scrollObject.push({
        el: el,
        delay: 0,
        isShow: false
      });
    });

    // スクロールで表示するdomを設定
    const bottomLink = this.el.querySelector('.p-home-bottom');
    TweenMax.set(bottomLink, {className: '+=is-hide'});
    this.scrollObject.push({
      el: bottomLink,
      delay: 0,
      isShow: false
    });

    // domの最大数
    this.max = this.scrollObject.length;

    // イベント
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {
    this.isStart = true;
    this.resizeUpdate();
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    if (!this.isStart) return;

    let isFinish = true;
    const posY = _scrollY + (window.innerHeight * 0.75);

    for (let i = 0; i < this.max; i++) {
      if (this.scrollObject[i].isShow) continue;

      isFinish = false;
      if (posY > AnyStore.getOffsetTop(this.scrollObject[i].el).top) {

        this.scrollObject[i].isShow = true;
        TweenMax.set(this.scrollObject[i].el, {className: '-=is-hide'});

        // 表示済みなので削除
        this.scrollObject.splice(i, 1);
        this.max = this.scrollObject.length;
        i--;
      }
    }

    if (isFinish) {
      // 全部表示した
      this.destroy();
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  /**
   * 削除
   */
  destroy() {
    this.scrollObject = [];
    ResizeWatch.cancelObserver(this.name);
    ScrollWatch.cancelObserver(this.name);
  }
}
